import { render, staticRenderFns } from "./v-datatable.vue?vue&type=template&id=74a02c72&scoped=true&"
import script from "./v-datatable.vue?vue&type=script&lang=js&"
export * from "./v-datatable.vue?vue&type=script&lang=js&"
import style0 from "./v-datatable.vue?vue&type=style&index=0&id=74a02c72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a02c72",
  null
  
)

export default component.exports